require.context('../images', true, /\.(png|jpg|jpeg|svg)$/);
import RailsUjs from "@rails/ujs"
import Turbolinks from "turbolinks"
RailsUjs.start()
Turbolinks.start()
import $ from 'jquery';
global.$ = $;
global.jQuery = $;
//jquery.easing
import "jquery.easing/jquery.easing";
import 'bootstrap/dist/js/bootstrap';
import 'src/components/messages/bottom'
import { PacsearchTable } from '../src/pacsearch/components/PacsearchTable.ts'


$(document).on('turbolinks:load', function () {
  $('body').tooltip({
    selector: '[data-toggle="tooltip"]',
    container: 'body',
  });

  $('body').popover({
    selector: '[data-toggle="popover"]',
    container: 'body',
    html: true,
    trigger: 'hover',
  });
  new PacsearchTable();
});

// import Chart from 'chart.js/dist/Chart';
// import dt from 'datatables.net/js/jquery.dataTables';
// import 'datatables.net-bs4/js/dataTables.bootstrap4';
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js"
flatpickr.localize(Japanese);
import '../src/sbadmin2.js';
import '../src/lesinternal/common.scss';
